import SeoLandingPage from "@/components/SeoLandingPage";

const GitResetGuide = () => <SeoLandingPage pageKey="gitResetGuide" />;

export default GitResetGuide;
